import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const EASE = [0.22, 1, 0.36, 1];

const FAQS = [
    {
        q: "Skal vi selv sørge for strøm?",
        a: "Du skal have et stik med jord — enten et almindeligt 230V stik eller et CEE 16A kraftstik, der hvor vognen skal stå. Emhætterne brænder sammen uden! Har du ingen af delene, leverer vi en gasvogn, der kun kræver 220 volt og 13 ampere. Adapterkabel, forlængerledning og kabeltromle kan tilvælges i konfiguratoren.",
    },
    {
        q: "Er forespørgslen bindende?",
        a: "Nej, overhovedet ikke. Alle forespørgsler er 100% uforpligtende. Udfyld blot dit navn og telefonnummer — så ringer Jørgen dig op med et tilbud, og først når I siger ja, er der en aftale.",
    },
    {
        q: "Hvorfor står der ingen priser på siden?",
        a: "Fordi hver fest er forskellig. Prisen afhænger af menu, gæster, tilvalg og kørselsafstand — og vi giver hellere et ærligt, personligt tilbud end en standardpris. Bedre service og bedste priser.",
    },
    {
        q: "Hvor langt kører I?",
        a: "Vi kører over hele Sjælland, Fyn, Jylland og Øerne – Intet sted er for stort eller småt. For at vi med vognen stopper op.",
    },
    {
        q: "Hvad med depositum og aflysning?",
        a: "Der betales et depositum ved bestilling. Aflyses festen under en uge før, tilbagebetales depositummet ikke — ellers finder vi altid en løsning sammen.",
    },
    {
        q: "Hvad med vegetarer, veganere og glutenfri gæster?",
        a: "Både vegetarpølser, vegetarburger, veganerpølser og veganerburger kan tilvælges i konfiguratoren. Skal nogen undgå gluten, har vi desuden glutenfri pølsebrød og glutenfri burgerboller som tilvalg — så alle gæster er dækket.",
    },
];

export default function FaqSection() {
    return (
        <section id="faq" data-testid="faq-section" className="bg-paper py-28 sm:py-36">
            <div className="mx-auto max-w-3xl px-5">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, ease: EASE }}
                    className="mb-14"
                >
                    <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-poelse">04 — FAQ</p>
                    <h2 className="font-serif text-2xl font-bold tracking-tight text-ink sm:text-3xl lg:text-4xl">
                        Ofte stillede spørgsmål
                    </h2>
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
                >
                    <Accordion type="single" collapsible className="w-full">
                        {FAQS.map((f, i) => (
                            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-border">
                                <AccordionTrigger className="text-left font-serif text-base font-semibold text-ink hover:text-poelse sm:text-lg">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-sm leading-relaxed text-muted-foreground sm:text-base">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </motion.div>
            </div>
        </section>
    );
}
